/** @format */

import React, { useState, useEffect, useContext } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { reportService } from "../../../Services/report.service";
import { globalServices } from "../../../Services/global.service";
import SpinnerLoading from "../../Common/SpinnerLoading";
import { GlobalContext } from "../../../Contexts/GlobalContextProvider";
import { useTranslation } from "react-i18next";
import iconcontentcalendar from "../../../Images/Icons/iconcontentcalendar.png";
import { useForm, Controller } from "react-hook-form";
import Tooltip from "../../../Components/Common/Tooltip";
import DatePicker, { registerLocale } from "react-datepicker";
import * as dateHelper from "../../../Helpers/DateHelper";
import moment from "moment";
import Select from "react-select";
import { AuthContext } from "../../../Contexts/AuthContext";
import { tipListServices } from "../../../Services/PDFservice/tiplist.service";
import hr from "date-fns/locale/hr";
import en from "date-fns/locale/en-US";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import AsyncSelect from "react-select/async";
import XLSX from "xlsx";
import { convertToDecimalString } from "../../../Helpers/DecimalNumberHelper";
import { activeCurrencyByDate } from "../../../Helpers/CurrencyConverter";

pdfMake.vfs = pdfFonts.pdfMake?.vfs;
registerLocale("hr", hr);
registerLocale("en", en);

const Table = () => {
  const {
    updateLocName,
    updateLocPos,
    updateLocTenant,
    updateLocStore,
    updateLocTab,
    selectedLanguageId,
    isMobile,
    locTenant,
  } = useContext(GlobalContext);

  const { t: translator } = useTranslation();
  const { handleSubmit, errors, control, setValue } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
  });
  const { userId, roleId, tenantId, tenantName } = useContext(AuthContext);
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [update, setUpdate] = useState(new Date());
  const [search, setSearch] = useState({
    tenantId:
      Number(localStorage.getItem("tenantId")) > 0
        ? Number(localStorage.getItem("tenantId"))
        : 0,
    validFrom: "",
    validTo: "",
    pageIndex: 0,
    pageSize: 10,
    searchText: "",
  });

  const [reportTag, setReportTag] = useState({
    tenantName: "",
    storeName: "",
    posName: "",
    date: "",
  });

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  let reportId = [];
  const [tenantObj, setTenantObj] = useState({
    id: 0,
    label: translator("Select-Tenant"),
    value: translator("Select-Tenant"),
  });
  useEffect(() => {
    updateLocName("invoices-invoiceTipsList");
    updateLocTenant(0);
    updateLocStore(0);
    updateLocPos(0);
    updateLocTab(0);
  });

  useEffect(() => {
    if (reportTag.date != "") {
      handleToSearch();
    }
  }, [update]);

  const promiseOptions = (inputValue) => {
    return globalServices
      .getTenants(
        Number(localStorage.getItem("tenantId")) > 0 ? userId : null,
        inputValue,
        Number(locTenant)
      )
      .then((res) => {
        var result = res.data.map((e) => ({
          id: e.id,
          label: e.name,
          value: e.name,
        }));

        return result;
      })
      .catch((err) => err);
  };

  // const getStores = (tenant) => {
  //   globalServices
  //     .getStoresByTenantId(tenant)
  //     .then((res) => {
  //       setStoresTag(res.data);
  //     })
  //     .catch((err) => console.log(err));
  // };

  // const getPos = (store) => {
  //   storeService
  //     .getPosByStoreId(store)
  //     .then((res) => {
  //       setPosTag(res.data);
  //     })
  //     .catch((err) => console.log(err));
  // };

  const handleToSearch = (event) => {
    let pageI = pagination.pageIndex;

    if (event) {
      pageI = 0;
    }

    setIsLoading(true);
    var m = moment();
    var date = moment(startDate);
    m.set(date.toObject());

    var m2 = moment();
    var date2 = moment(search.validTo);
    m2.set(date2.toObject());

    reportService
      .invoiceTipsList({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        year: m.year(),
        from: search.validFrom,
        to: search.validTo == "" ? "" : m2.endOf("day").format(),
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        setReports(res.data.data);
        setPagination({
          ...pagination,
          totalCount: res.data.totalCount,
          pageIndex: pageI,
        });
        setIsLoading(false);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSearch({ ...search, [name]: value });
  };

  const handleTableChange = (type, { page, sizePerPage }) => {
    setPagination({
      ...pagination,
      pageIndex: sizePerPage != pagination.pageSize ? 0 : page - 1,
      pageSize: sizePerPage,
    });

    setUpdate(new Date());
  };

  const rowEvents = {
    onClick: (e, row, rowIndex) => {},
  };

  const rowClasses = (row, rowIndex) => {
    if (row.payValue === 0) {
      return "text-danger";
    } else {
      return "boostrap-table-row";
    }
  };

  const RemoteAll = ({ data, page, totalSize, onTableChange }) => (
    <div>
      <BootstrapTable
        showHeader={false}
        remote
        keyField="reportId"
        data={data}
        columns={columns}
        rowEvents={rowEvents}
        noDataIndication={translator("No-Data")}
        rowClasses={rowClasses}
        pagination={paginationFactory({
          page,
          hideSizePerPage: true,
          totalSize,
        })}
        onTableChange={onTableChange}
      />
    </div>
  );

  function currencyFormatter(cell, row) {
    return new Intl.NumberFormat("hr", {
      style: "currency",
      currency: activeCurrencyByDate(row?.issued),
    }).format(Number(cell));
  }

  function dateTimeFormatter(cell, row) {
    return new Intl.DateTimeFormat("hr", {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: false,
      timeZone: "Europe/Zagreb",
    }).format(new Date(cell));
  }
  const columns = [
    {
      dataField: "oib",
      text: translator("Oib"),
      headerStyle: () => {
        return { width: "300px" };
      },
      style: () => {
        return { width: "300px" };
      },
    },
    {
      dataField: "fullName",
      text: translator("Korisnik"),

      hidden: Boolean(isMobile),
    },
    {
      dataField: "amount",
      text: translator("Iznos"),
      formatter: currencyFormatter,
    },
  ];

  const exportFunction = () => {
    var m = moment();
    var date = moment(startDate);
    m.set(date.toObject());
    var m2 = moment();
    var date2 = moment(search.validTo);
    m2.set(date2.toObject());
    reportService
      .invoiceTipsList({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        year: m.year(),
        from: search.validFrom,
        to: search.validTo == "" ? "" : m2.endOf("day").format(),
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        tipListServices.handlePrint(res.data.data, reportTag, translator);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  const exportExcelFunction = () => {
    var m = moment();
    var date = moment(startDate);
    m.set(date.toObject());
    var m2 = moment();
    var date2 = moment(search.validTo);
    m2.set(date2.toObject());
    reportService
      .invoiceTipsList({
        tenantId:
          localStorage.getItem("tenantId") === "null"
            ? Number(search.tenantId)
            : Number(localStorage.getItem("tenantId")),
        year: m.year(),
        from: search.validFrom,
        to: search.validTo == "" ? "" : m2.endOf("day").format(),
        pageIndex: pagination.pageIndex,
        pageSize: pagination.pageSize,
      })
      .then((res) => {
        // File name
        var ws_name = `${translator("InvoiceList-PDFTitle").slice(0, 25)}.xlsx`;
        // New work book
        var wb = XLSX.utils.book_new();
        const month = reportTag.date.getMonth() + 1;
        const year = reportTag.date.getFullYear();
        // Constant Data
        var ws_data = [
          [translator("InvIssReport-Filters-Tenants"), tenantObj.label],
          [translator("InvoiceCashBalancePDF-Date"), month + " / " + year],
          [
            translator("InvoiceListPdf-DocNum"),
            translator("InvoiceConclCashBalancePDF-Issued"),
            translator("InvoiceConclCashBalancePDF-Amount"),
          ],
        ];
        // Inconsistent data / Reports
        const ws_sufix = res.data.data.map((x) => {
          const array = [
            `${x.documentNumber}/${x.storeTag}/${x.posTag}`,
            dateTimeFormatter(x.issued),
            x.payValue,
          ];
          return array;
        });
        // Merge data
        ws_data = [...ws_data, ...ws_sufix];
        // Export to xlsx
        const ws = XLSX.utils.aoa_to_sheet(ws_data);
        ws["!cols"] = [{ width: 13 }, { width: 22 }, { width: 15 }];
        XLSX.utils.book_append_sheet(wb, ws, ws_name);
        XLSX.writeFile(wb, ws_name);
      })
      .catch((err) => {
        console.error(err.response);
      });
  };

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>{translator("TipsReport-Title")}</span>
        </div>

        <div className="card-body">
          <fieldset className="scheduler-border">
            <form className="row" onSubmit={handleSubmit(handleToSearch)}>
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-4 col-xs-12">
                    <label htmlFor="ddlTenants">
                      {translator("TipsReport-Filters-Tenants")}
                    </label>
                    <Controller
                      as={AsyncSelect}
                      control={control}
                      name="tenantId"
                      rules={{
                        validate: function (value) {
                          if (!value) return false;
                          return value.value === 0 ? false : true;
                        },
                      }}
                      onChange={function (event) {
                        setValue("storeTag", null);
                        setValue("posTag", null);
                        setTenantObj({
                          id: event[0].id,
                          label: event[0].label,
                          value: event[0].value,
                        });
                        setSearch({
                          ...search,
                          tenantId: event[0].id,
                        });
                        setReportTag({
                          ...reportTag,
                          tenantName: event[0].label,
                        });

                        //setReports([]);

                        return event[0];
                      }}
                      defaultOptions={true}
                      loadOptions={promiseOptions}
                      placeholder={translator("Select-Tenant")}
                      value={tenantObj}
                    />
                    {errors.tenantId && errors.tenantId.type === "validate" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-Year")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        selected={startDate}
                        valueName="selected"
                        name="from"
                        rules={{ required: false }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        onChange={function ([selected]) {
                          setStartDate(selected);

                          handleInputChange({
                            target: {
                              name: "from",
                              value: selected,
                            },
                          });
                          setReportTag({
                            ...reportTag,
                            date: selected,
                          });
                          //setReports([]);
                          return selected;
                        }}
                        dateFormat="yyyy"
                        showYearPicker
                      />
                      {errors.from && errors.from.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              }
              {
                <>
                  <div className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidFrom")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        maxDate={
                          search && search.validTo && new Date(search.validTo)
                        }
                        as={DatePicker}
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="validFrom"
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        rules={{ required: false }}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "validFrom",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          setValue("validTo", null);
                          setReportTag({
                            ...reportTag,
                            dateFrom: selected,
                          });
                          //setReports([]);
                          return selected;
                        }}
                      />
                    </div>
                    {errors.validFrom &&
                      errors.validFrom.type === "required" && (
                        <p className="text-danger">
                          {translator("ValidationMsg-RequiredField")}
                        </p>
                      )}
                  </div>
                </>
              }
              {
                <>
                  <div className="form-group col-lg-3 col-md-3 col-sm-6 col-xs-12">
                    <label>{translator("InvIssReport-ValidTo")}</label>
                    <div className="input-group mb-2">
                      <div className="input-group-prepend">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={iconcontentcalendar} alt="calendar" />
                        </span>
                      </div>
                      <Controller
                        disabled={search && search.validFrom ? false : true}
                        as={DatePicker}
                        minDate={
                          search &&
                          search.validFrom &&
                          new Date(search.validFrom)
                        }
                        maxDate={
                          search &&
                          search.validFrom &&
                          new Date(
                            new Date(search.validFrom).getFullYear(),
                            11,
                            31
                          )
                        }
                        control={control}
                        autoComplete="off"
                        className="form-control"
                        dateFormat="dd.MM.yyyy"
                        showYearDropdown={true}
                        name="validTo"
                        rules={{ required: false }}
                        locale={Number(selectedLanguageId) === 1 ? "hr" : "en"}
                        valueName="selected"
                        onChange={function ([selected]) {
                          handleInputChange({
                            target: {
                              name: "validTo",
                              value: dateHelper.datePickerDateToUtc(selected),
                            },
                          });
                          setReportTag({
                            ...reportTag,
                            dateTo: selected,
                          });
                          //setReports([]);
                          return selected;
                        }}
                      />
                    </div>
                    {errors.validTo && errors.validTo.type === "required" && (
                      <p className="text-danger">
                        {translator("ValidationMsg-RequiredField")}
                      </p>
                    )}
                  </div>
                </>
              }
              {
                <>
                  <div
                    style={{ marginTop: "-28px" }}
                    className="form-group col-lg-3 col-md-4 col-sm-6 col-xs-12"
                  >
                    <label>{""}</label>
                    <div className="form-group">
                      <button
                        className="btn btn-primary pull-left mt-2"
                        type="submit"
                      >
                        <span className="icon icon-search"></span>{" "}
                        {translator("TipsReport-Btn-Search")}
                      </button>
                    </div>
                  </div>
                </>
              }
            </form>
          </fieldset>

          {isLoading && (
            <div className="dashboard-card-spinner">
              <SpinnerLoading />
            </div>
          )}

          {!isLoading && (
            <RemoteAll
              data={reports}
              page={pagination.pageIndex + 1}
              sizePerPage={pagination.pageSize}
              totalSize={pagination.totalCount}
              onTableChange={handleTableChange}
            />
          )}

          {reports.length !== 0 ? (
            <>
              <button
                className="btn btn-outline-secondary"
                onClick={exportFunction}
              >
                <i className="fas fa-file-pdf"></i>{" "}
                {translator("Reports-PrintBtn")}
              </button>
              {"  "}
              <button
                className="btn btn-outline-secondary"
                onClick={exportExcelFunction}
              >
                <i className="fas fa-file-alt"></i>{" "}
                {translator("Reports-PrintExclBtn")}
              </button>
            </>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Table;
